import { DocumentOrientation, PossibleFlyerType, TemplateConfig } from "pages/flyer/builder/drawer/types";
import fonts from "pages/flyer/builder/fonts";
const FrontSideA6 = `${process.env.PUBLIC_URL}/static/media/PrintRuleFrontSideA6.svg`;
const BackSideA6 = `${process.env.PUBLIC_URL}/static/media/PrintRuleBackSideA6.svg`;
import FrontSideDoorHanger from "static/media/PrintRuleFrontSideDoorHanger.jpg";
import BackSideDoorHanger from "static/media/PrintRuleBackSideDoorHanger.jpg";
import {
  DocumentFormats,
  DMDocumentFormats,
  DMDocumentNames,
  DocumentNames,
  ADMDocumentFormats,
  ADMDocumentLabels,
} from "shared/constants";
import DoorHangerFlyerEPS from "../../../static/files/DoorHangerFlyer.eps";

import A5FlyerPrintingRulesMm from "../../../static/files/A5_printing_rules_mm.pdf";
import A5FlyerPrintingRulesInches from "../../../static/files/A5_printing_rules_inches.pdf";
import PreviewA5Placeholder from "./../upload/assets/PreviewA5.png";
import PreviewA5 from "./../upload/assets/PreviewA5Transparent.png";
import A5HorizontalArrow from "./../upload/assets/A5HorizontalArrow.png";
import A5VerticalArrow from "./../upload/assets/A5VerticalArrow.png";

import A6Example from "./../upload/assets/ExampleA6.png";
import A6_Temlate from "../../../static/files/A6.eps";
import A6FlyerPrintingRulesMm from "../../../static/files/A6_printing_rules_mm.pdf";
import A6FlyerPrintingRulesInches from "../../../static/files/A6_printing_rules_inches.pdf";
import PreviewA6Placeholder from "./../upload/assets/PreviewA6.png";
import PreviewA6 from "./../upload/assets/PreviewA6Transparent.png";
import A6HorizontalArrow from "./../upload/assets/A6HorizontalArrow.png";
import A6VerticalArrow from "./../upload/assets/A6VerticalArrow.png";

import ExampleDoorHanger from "./../upload/assets/ExampleDoorHanger.png";
import DoorHangerPrintingRulesMm from "../../../static/files/DH_printing_rules_mm.pdf";
import DoorHangerPrintingRulesInches from "../../../static/files/DH_printing_rules_inches.pdf";
import PreviewDoorHangerPlaceholder from "./../upload/assets/PreviewDoorHanger.png";
import PreviewDoorHanger from "./../upload/assets/PreviewDoorHangerTransparent.png";
import DoorHangerHorizontalArrow from "./../upload/assets/DoorHangerHorizontalArrow.png";
import DoorHangerVerticalArrow from "./../upload/assets/DoorHangerVerticalArrow.png";

import TearawayPrintingRulesMm from "../../../static/files/TR_Printing_rules_mm.pdf";
import TearawayPrintingRulesInches from "../../../static/files/TR_Printing_rules_inches.pdf";
import PreviewTearawayPlaceholder from "./../upload/assets/PreviewTearaway.png";
import PreviewTearaway from "./../upload/assets/PreviewTearawayTransparent.png";
import TearawayHorizontalArrow from "./../upload/assets/TearawayHorizontalArrow.png";
import TearawayVerticalArrow from "./../upload/assets/TearawayVerticalArrow.png";

import DLPrintingRulesMm from "../../../static/files/DL_printing_rules_mm.pdf";
import DLPrintingRulesInches from "../../../static/files/DL_printing_rules_inches.pdf";
import PreviewDLPlaceholder from "./../upload/assets/PreviewDL.png";
import PreviewDL from "./../upload/assets/PreviewDLTransparent.png";
import DLHorizontalArrow from "./../upload/assets/DLHorizontalArrow.png";
import DLVerticalArrow from "./../upload/assets/DLVerticalArrow.png";

import SmallFlyerPrintingRulesInches from "../../../static/files/Small_printing_rules_inches.pdf";
import PreviewSmallPlaceholder from "./../upload/assets/PreviewSmall.png";
import PreviewSmall from "./../upload/assets/PreviewSmallTransparent.png";
import SmallHorizontalArrow from "./../upload/assets/SmallHorizontalArrow.png";
import SmallVerticalArrow from "./../upload/assets/SmallVerticalArrow.png";
import SmallFlyerTemplate from "../../../static/files/Small_4.25x11.6_postcard_templates.zip";

import BestsellerFlyerPrintingRulesInches from "../../../static/files/Bestseller_printing_rules_inches.pdf";
import PreviewBestSellerPlaceholder from "./../upload/assets/PreviewBestSeller.png";
import PreviewBestSeller from "./../upload/assets/PreviewBestSellerTransparent.png";
import BestSellerHorizontalArrow from "./../upload/assets/BestSellerHorizontalArrow.png";
import BestSellerVerticalArrow from "./../upload/assets/BestSellerVerticalArrow.png";
import BestSellerFlyerTemplate from "../../../static/files/Best_seller_6.25x9_postcard_templates.zip";

import LargeFlyerPrintingRulesInches from "../../../static/files/Large_printing_rules_inches.pdf";
import PreviewLargePlaceholder from "./../upload/assets/PreviewLarge.png";
import PreviewLarge from "./../upload/assets/PreviewLargeTransparent.png";
import LargeHorizontalArrow from "./../upload/assets/LargeHorizontalArrow.png";
import LargeVerticalArrow from "./../upload/assets/LargeVerticalArrow.png";
import LargeFlyerTemplate from "../../../static/files/Large_6.25x11_postcard_templates.zip";

import JumboFlyerPrintingRulesInches from "../../../static/files/Jumbo_printing_rules_inches.pdf";
import PreviewJumboPlaceholder from "./../upload/assets/PreviewJumbo.png";
import PreviewJumbo from "./../upload/assets/PreviewJumboTransparent.png";
import JumboHorizontalArrow from "./../upload/assets/JumboHorizontalArrow.png";
import JumboVerticalArrow from "./../upload/assets/JumboVerticalArrow.png";
import JumboFlyerTemplate from "../../../static/files/Jumbo_8.5x11_postcard_templates.zip";

import OversizedFlyerPrintingRulesInches from "../../../static/files/Oversized_printing_rules_inches.pdf";
import PreviewOversizedPlaceholder from "./../upload/assets/PreviewOversized.png";
import PreviewOversized from "./../upload/assets/PreviewOversizedTransparent.png";
import OversizedHorizontalArrow from "./../upload/assets/OversizedHorizontalArrow.png";
import OversizedVerticalArrow from "./../upload/assets/OversizedVerticalArrow.png";
import OversizedFlyerTemplate from "../../../static/files/Oversized_12x15_postcard_template.zip";

import a4 from "../../../static/media/formats/a4-preview.png";
import a5 from "../../../static/media/formats/a5-preview.png";
import a6 from "../../../static/media/formats/a6-preview.png";
import doorhanger from "../../../static/media/formats/doorhanger-preview.png";
import dl from "../../../static/media/formats/dl-preview.png";
import tearaway from "../../../static/media/formats/tearaway-preview.png";
import postcard4x6 from "../../../static/media/formats/postcard-4x6-preview.png";
import postcard4_25x11 from "../../../static/media/formats/postcard-4-25x11-preview.png";
import postcard6_25x9 from "../../../static/media/formats/postcard-6-25x9-preview.png";
import postcard6_25x11 from "../../../static/media/formats/postcard-6-25x11-preview.png";

import ADMPostcard6x4Templates from "../../../static/files/postcard-4x6-templates.zip";
import ADMPostcard9x6Templates from "../../../static/files/postcard-6x9-templates.zip";
import ADMPostcard11x6Templates from "../../../static/files/postcard-6x11-templates.zip";

export const BUILDER_COLORS = {
  NEW_COLOR: {
    color: "#e3e3e333",
    isHidden: false,
  },
  NEW_SHADOW_COLOR: "#00000040",
  NEW_SHADOW_DX: 0,
  NEW_SHADOW_DY: 2,
  NEW_SHADOW_BLUR: 1.5,
  NEW_SHADOW_OPACITY: 1,
  NEW_SHADOW_IS_HIDDEN: false,
};

export const FORMATS: Partial<Record<PossibleFlyerType, TemplateConfig>> = {
  A4: {
    template: DoorHangerFlyerEPS,
    printingRulesMm: A5FlyerPrintingRulesMm,
    printingRulesInches: A5FlyerPrintingRulesInches,
    flyerTemplate: "",
    name: DocumentNames.A4,
    format: DocumentFormats.A4 as PossibleFlyerType,
    width: 794,
    height: 1122,
    example: ExampleDoorHanger,
    preview: PreviewA5,
    placeholder: PreviewA5Placeholder,
    frontSide: FrontSideDoorHanger,
    backSide: BackSideDoorHanger,
    size: "210 x 297",
    measuring: "mm",
    widthInMm: 210,
    heightInMm: 297,
    displayWidth: 794,
    displayHeight: 1122,
    gapForArrow: 25,
    previewPadding: 0,
    horizontalArrow: A5HorizontalArrow,
    verticalArrow: A5VerticalArrow,
    verticalArrowHeight: 698,
    horizontalArrowWidth: 524,
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzNzkuMyA1MzMuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzc5LjMgNTMzLjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDY3LjgsMzg3LjZIMzYuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjM1LjVjMC02LjMsNS4xLTExLjMsMTEuMy0xMS4zaDQzOC4zYzYuMywwLDExLjMsNS4xLDExLjMsMTEuMwoJCXYzMzAuOEM0NzkuMSwzODIuNiw0NzQsMzg3LjYsNDY3LjgsMzg3LjZ6Ii8+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDY3LjgsNTE5LjRIMzYuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjQwOVYzOTAuOWMwLTYuMyw1LjEtMTEuMywxMS4zLTExLjNoNDM4LjNjNi4zLDAsMTEuMyw1LjEsMTEuMywxMS4zCgkJVjUxM0M0NzkuMSw1MTQuMyw0NzQsNTE5LjQsNDY3LjgsNTE5LjR6Ii8+CjwvZz4KPC9zdmc+Cg==",
    defaultOrientation: DocumentOrientation.Portrait,
    price: "$$",
  },

  A5: {
    template: DoorHangerFlyerEPS,
    printingRulesMm: A5FlyerPrintingRulesMm,
    printingRulesInches: A5FlyerPrintingRulesInches,
    flyerTemplate: "",
    name: DocumentNames.A5,
    format: DocumentFormats.A5 as PossibleFlyerType,
    width: 559,
    height: 794,
    example: ExampleDoorHanger,
    preview: PreviewA5,
    placeholder: PreviewA5Placeholder,
    frontSide: FrontSideDoorHanger,
    backSide: BackSideDoorHanger,
    size: "148 x 210",
    measuring: "mm",
    widthInMm: 148,
    heightInMm: 210,
    displayWidth: 559,
    displayHeight: 794,
    gapForArrow: 17,
    previewPadding: 0,
    horizontalArrow: A5HorizontalArrow,
    verticalArrow: A5VerticalArrow,
    verticalArrowHeight: 528,
    horizontalArrowWidth: 373,
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNjkuMyA0NTMuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjY5LjMgNDUzLjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsMjk3LjZIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjI1LjVjMC02LjMsNS4xLTExLjMsMTEuMy0xMS4zaDIxOC4zYzYuMywwLDExLjMsNS4xLDExLjMsMTEuMwoJCXYyNjAuOEMyNTUuMSwyOTIuNiwyNTAsMjk3LjYsMjQzLjgsMjk3LjZ6Ii8+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsNDM5LjRIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjMwOWMwLTYuMyw1LjEtMTEuMywxMS4zLTExLjNoMjE4LjNjNi4zLDAsMTEuMyw1LjEsMTEuMywxMS4zCgkJVjQyOEMyNTUuMSw0MzQuMywyNTAsNDM5LjQsMjQzLjgsNDM5LjR6Ii8+CjwvZz4KPC9zdmc+Cg==",
    defaultOrientation: DocumentOrientation.Portrait,
    price: "$$",
  },
  A6: {
    template: A6_Temlate,
    printingRulesMm: A6FlyerPrintingRulesMm,
    printingRulesInches: A6FlyerPrintingRulesInches,
    name: DocumentNames.A6,
    format: DocumentFormats.A6 as PossibleFlyerType,
    flyerTemplate: "",
    frontSide: FrontSideA6,
    backSide: BackSideA6,
    example: A6Example,
    preview: PreviewA6,
    placeholder: PreviewA6Placeholder,
    size: "105 × 148",
    measuring: "mm",
    widthInMm: 105,
    heightInMm: 148,
    displayWidth: 419.5,
    displayHeight: 582,
    previewPadding: 0,
    gapForArrow: 22,
    gapForHorizontalArrow: 28,
    horizontalArrow: A6HorizontalArrow,
    verticalArrow: A6VerticalArrow,
    verticalArrowHeight: 550,
    horizontalArrowWidth: 388,
    width: 419.5, // 111 mm (include bleed area)
    height: 582, // 154 mm (include bleed area)
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMTcuNSA0NTkuMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzE3LjUgNDU5LjI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojMDEwMjAyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPHJlY3QgeD0iMTQuMiIgeT0iMTQuMiIgY2xhc3M9InN0MCIgd2lkdGg9IjI4OS4xIiBoZWlnaHQ9IjQzMC45Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSI5LjkiIHkxPSIxNC4yIiB4Mj0iMCIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iNDQ5LjMiIHgyPSIzMDMuMyIgeTI9IjQ1OS4yIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjQ0NSIgeDI9IjMxNy41IiB5Mj0iNDQ1Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjE0LjIiIHgyPSIzMTcuNSIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iOS45IiB4Mj0iMzAzLjMiIHkyPSIwIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIxNC4yIiB5MT0iOS45IiB4Mj0iMTQuMiIgeTI9IjAiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjE0LjIiIHkxPSI0NDkuMyIgeDI9IjE0LjIiIHkyPSI0NTkuMiIvPgo8bGluZSBjbGFzcz0ic3QxIiB4MT0iOS45IiB5MT0iNDQ1IiB4Mj0iMCIgeTI9IjQ0NSIvPgo8L3N2Zz4K",
    defaultOrientation: DocumentOrientation.Portrait,
    price: "$$",
  },
  DOOR_HANGER: {
    template: DoorHangerFlyerEPS,
    printingRulesMm: DoorHangerPrintingRulesMm,
    printingRulesInches: DoorHangerPrintingRulesInches,
    name: DocumentNames.DOOR_HANGER,
    format: DocumentFormats.DOOR_HANGER as PossibleFlyerType,
    flyerTemplate: "",
    width: 359,
    height: 839, // (mm) = 3.74 x 8.74 in (bleed area)
    example: ExampleDoorHanger,
    preview: PreviewDoorHanger,
    placeholder: PreviewDoorHangerPlaceholder,
    frontSide: FrontSideDoorHanger,
    backSide: BackSideDoorHanger,
    size: "3.74 x 8.74",
    measuring: "in",
    widthInMm: 95,
    heightInMm: 222,
    displayWidth: 359,
    displayHeight: 839,
    previewPadding: 0,
    gapForArrow: 14,
    horizontalArrow: DoorHangerHorizontalArrow,
    verticalArrow: DoorHangerVerticalArrow,
    verticalArrowHeight: 547,
    horizontalArrowWidth: 227,
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMTcuNSA0NTkuMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzE3LjUgNDU5LjI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojMDEwMjAyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPHJlY3QgeD0iMTQuMiIgeT0iMTQuMiIgY2xhc3M9InN0MCIgd2lkdGg9IjI4OS4xIiBoZWlnaHQ9IjQzMC45Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSI5LjkiIHkxPSIxNC4yIiB4Mj0iMCIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iNDQ5LjMiIHgyPSIzMDMuMyIgeTI9IjQ1OS4yIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjQ0NSIgeDI9IjMxNy41IiB5Mj0iNDQ1Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjE0LjIiIHgyPSIzMTcuNSIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iOS45IiB4Mj0iMzAzLjMiIHkyPSIwIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIxNC4yIiB5MT0iOS45IiB4Mj0iMTQuMiIgeTI9IjAiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjE0LjIiIHkxPSI0NDkuMyIgeDI9IjE0LjIiIHkyPSI0NTkuMiIvPgo8bGluZSBjbGFzcz0ic3QxIiB4MT0iOS45IiB5MT0iNDQ1IiB4Mj0iMCIgeTI9IjQ0NSIvPgo8L3N2Zz4K",
    defaultOrientation: DocumentOrientation.Portrait,
    price: "$$$",
  },
  TEARAWAY: {
    template: DoorHangerFlyerEPS,
    printingRulesMm: TearawayPrintingRulesMm,
    printingRulesInches: TearawayPrintingRulesInches,
    name: DocumentNames.TEARAWAY,
    format: DocumentFormats.TEARAWAY as PossibleFlyerType,
    flyerTemplate: "",
    width: 321,
    height: 567,
    example: ExampleDoorHanger,
    preview: PreviewTearaway,
    placeholder: PreviewTearawayPlaceholder,
    frontSide: FrontSideDoorHanger,
    backSide: BackSideDoorHanger,
    size: "85 x 150",
    measuring: "mm",
    widthInMm: 85,
    heightInMm: 150,
    displayWidth: 321,
    displayHeight: 567,
    previewPadding: 0,
    gapForArrow: 20,
    horizontalArrow: TearawayHorizontalArrow,
    verticalArrow: TearawayVerticalArrow,
    verticalArrowHeight: 541,
    horizontalArrowWidth: 307,
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNjkuMyA0NTMuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjY5LjMgNDUzLjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsMjk3LjZIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjI1LjVjMC02LjMsNS4xLTExLjMsMTEuMy0xMS4zaDIxOC4zYzYuMywwLDExLjMsNS4xLDExLjMsMTEuMwoJCXYyNjAuOEMyNTUuMSwyOTIuNiwyNTAsMjk3LjYsMjQzLjgsMjk3LjZ6Ii8+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsNDM5LjRIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjMwOWMwLTYuMyw1LjEtMTEuMywxMS4zLTExLjNoMjE4LjNjNi4zLDAsMTEuMyw1LjEsMTEuMywxMS4zCgkJVjQyOEMyNTUuMSw0MzQuMywyNTAsNDM5LjQsMjQzLjgsNDM5LjR6Ii8+CjwvZz4KPC9zdmc+Cg==",
    defaultOrientation: DocumentOrientation.Portrait,
    price: "$$$",
  },
  DL: {
    template: DoorHangerFlyerEPS,
    printingRulesMm: DLPrintingRulesMm,
    printingRulesInches: DLPrintingRulesInches,
    name: DocumentNames.DL,
    format: DocumentFormats.DL as PossibleFlyerType,
    flyerTemplate: "",
    width: 374,
    height: 794,
    example: ExampleDoorHanger,
    preview: PreviewDL,
    placeholder: PreviewDLPlaceholder,
    frontSide: FrontSideDoorHanger,
    backSide: BackSideDoorHanger,
    size: "99 x 210",
    measuring: "mm",
    widthInMm: 99,
    heightInMm: 210,
    displayWidth: 374,
    displayHeight: 794,
    previewPadding: 0,
    gapForArrow: 15,
    horizontalArrow: DLHorizontalArrow,
    verticalArrow: DLVerticalArrow,
    verticalArrowHeight: 558,
    horizontalArrowWidth: 264,
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNjkuMyA0NTMuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjY5LjMgNDUzLjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsMjk3LjZIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjI1LjVjMC02LjMsNS4xLTExLjMsMTEuMy0xMS4zaDIxOC4zYzYuMywwLDExLjMsNS4xLDExLjMsMTEuMwoJCXYyNjAuOEMyNTUuMSwyOTIuNiwyNTAsMjk3LjYsMjQzLjgsMjk3LjZ6Ii8+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsNDM5LjRIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjMwOWMwLTYuMyw1LjEtMTEuMywxMS4zLTExLjNoMjE4LjNjNi4zLDAsMTEuMyw1LjEsMTEuMywxMS4zCgkJVjQyOEMyNTUuMSw0MzQuMywyNTAsNDM5LjQsMjQzLjgsNDM5LjR6Ii8+CjwvZz4KPC9zdmc+Cg==",
    defaultOrientation: DocumentOrientation.Portrait,
    price: "$$$",
  },
  SMALL: {
    template: A6_Temlate,
    printingRulesMm: A6FlyerPrintingRulesMm,
    printingRulesInches: SmallFlyerPrintingRulesInches,
    name: DMDocumentNames.SMALL,
    format: DMDocumentFormats.SMALL as PossibleFlyerType,
    flyerTemplate: SmallFlyerTemplate,
    frontSide: FrontSideA6,
    backSide: BackSideA6,
    example: A6Example,
    preview: PreviewSmall,
    placeholder: PreviewSmallPlaceholder,
    size: "107.95 × 294.64", // 4.25in x 11.6in on mm
    measuring: "mm",
    heightInMm: 107.95, // 4.25 inch
    widthInMm: 294.64, // 11.6 inch
    displayHeight: 408, // 107.95mm * 3.78
    displayWidth: 1114, // 294.64mm * 3.78
    previewPadding: 0,
    gapForArrow: 14,
    gapForHorizontalArrow: 23,
    horizontalArrow: SmallHorizontalArrow,
    verticalArrow: SmallVerticalArrow,
    verticalArrowHeight: 227,
    horizontalArrowWidth: 649,
    width: 1114, // 294.64mm * 3.78
    height: 408, // 107.95mm * 3.78
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMTcuNSA0NTkuMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzE3LjUgNDU5LjI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojMDEwMjAyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPHJlY3QgeD0iMTQuMiIgeT0iMTQuMiIgY2xhc3M9InN0MCIgd2lkdGg9IjI4OS4xIiBoZWlnaHQ9IjQzMC45Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSI5LjkiIHkxPSIxNC4yIiB4Mj0iMCIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iNDQ5LjMiIHgyPSIzMDMuMyIgeTI9IjQ1OS4yIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjQ0NSIgeDI9IjMxNy41IiB5Mj0iNDQ1Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjE0LjIiIHgyPSIzMTcuNSIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iOS45IiB4Mj0iMzAzLjMiIHkyPSIwIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIxNC4yIiB5MT0iOS45IiB4Mj0iMTQuMiIgeTI9IjAiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjE0LjIiIHkxPSI0NDkuMyIgeDI9IjE0LjIiIHkyPSI0NTkuMiIvPgo8bGluZSBjbGFzcz0ic3QxIiB4MT0iOS45IiB5MT0iNDQ1IiB4Mj0iMCIgeTI9IjQ0NSIvPgo8L3N2Zz4K",
    defaultOrientation: DocumentOrientation.Landscape,
    price: "$",
  },
  BEST_SELLER: {
    template: A6_Temlate,
    printingRulesMm: A6FlyerPrintingRulesMm,
    printingRulesInches: BestsellerFlyerPrintingRulesInches,
    name: DMDocumentNames.BEST_SELLER,
    format: DMDocumentFormats.BEST_SELLER as PossibleFlyerType,
    flyerTemplate: BestSellerFlyerTemplate,
    frontSide: FrontSideA6,
    backSide: BackSideA6,
    example: A6Example,
    preview: PreviewBestSeller,
    placeholder: PreviewBestSellerPlaceholder,
    size: "105 × 148",
    measuring: "mm",
    heightInMm: 158.75, // 6.25 inch
    widthInMm: 228.6, // 9 inch
    displayWidth: 864, // 228.6mm * 3.78
    displayHeight: 600, // 158.75mm * 3.78
    previewPadding: 0,
    gapForArrow: 14,
    horizontalArrow: BestSellerHorizontalArrow,
    verticalArrow: BestSellerVerticalArrow,
    verticalArrowHeight: 340,
    horizontalArrowWidth: 496,
    width: 864, // 228.6mm * 3.78
    height: 600, // 158.75mm * 3.78
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMTcuNSA0NTkuMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzE3LjUgNDU5LjI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojMDEwMjAyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPHJlY3QgeD0iMTQuMiIgeT0iMTQuMiIgY2xhc3M9InN0MCIgd2lkdGg9IjI4OS4xIiBoZWlnaHQ9IjQzMC45Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSI5LjkiIHkxPSIxNC4yIiB4Mj0iMCIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iNDQ5LjMiIHgyPSIzMDMuMyIgeTI9IjQ1OS4yIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjQ0NSIgeDI9IjMxNy41IiB5Mj0iNDQ1Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjE0LjIiIHgyPSIzMTcuNSIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iOS45IiB4Mj0iMzAzLjMiIHkyPSIwIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIxNC4yIiB5MT0iOS45IiB4Mj0iMTQuMiIgeTI9IjAiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjE0LjIiIHkxPSI0NDkuMyIgeDI9IjE0LjIiIHkyPSI0NTkuMiIvPgo8bGluZSBjbGFzcz0ic3QxIiB4MT0iOS45IiB5MT0iNDQ1IiB4Mj0iMCIgeTI9IjQ0NSIvPgo8L3N2Zz4K",
    defaultOrientation: DocumentOrientation.Landscape,
    price: "$$",
  },
  LARGE: {
    template: A6_Temlate,
    printingRulesMm: A6FlyerPrintingRulesMm,
    printingRulesInches: LargeFlyerPrintingRulesInches,
    name: DMDocumentNames.LARGE,
    format: DMDocumentFormats.LARGE as PossibleFlyerType,
    flyerTemplate: LargeFlyerTemplate,
    frontSide: FrontSideA6,
    backSide: BackSideA6,
    example: A6Example,
    preview: PreviewLarge,
    placeholder: PreviewLargePlaceholder,
    size: "105 × 148",
    measuring: "mm",
    heightInMm: 158.75, // 6.25 inch
    widthInMm: 279.4, // 11 inch
    displayWidth: 1056, // 279.4mm * 3.78
    displayHeight: 600, // 158.75mm * 3.78
    previewPadding: 0,
    gapForArrow: 14,
    horizontalArrow: LargeHorizontalArrow,
    verticalArrow: LargeVerticalArrow,
    verticalArrowHeight: 340,
    horizontalArrowWidth: 609,
    width: 1056, // 279.4mm * 3.78
    height: 600, // 158.75mm * 3.78
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMTcuNSA0NTkuMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzE3LjUgNDU5LjI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojMDEwMjAyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPHJlY3QgeD0iMTQuMiIgeT0iMTQuMiIgY2xhc3M9InN0MCIgd2lkdGg9IjI4OS4xIiBoZWlnaHQ9IjQzMC45Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSI5LjkiIHkxPSIxNC4yIiB4Mj0iMCIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iNDQ5LjMiIHgyPSIzMDMuMyIgeTI9IjQ1OS4yIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjQ0NSIgeDI9IjMxNy41IiB5Mj0iNDQ1Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjE0LjIiIHgyPSIzMTcuNSIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iOS45IiB4Mj0iMzAzLjMiIHkyPSIwIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIxNC4yIiB5MT0iOS45IiB4Mj0iMTQuMiIgeTI9IjAiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjE0LjIiIHkxPSI0NDkuMyIgeDI9IjE0LjIiIHkyPSI0NTkuMiIvPgo8bGluZSBjbGFzcz0ic3QxIiB4MT0iOS45IiB5MT0iNDQ1IiB4Mj0iMCIgeTI9IjQ0NSIvPgo8L3N2Zz4K",
    defaultOrientation: DocumentOrientation.Landscape,
    price: "$$$",
  },
  JUMBO: {
    template: A6_Temlate,
    printingRulesMm: A6FlyerPrintingRulesMm,
    printingRulesInches: JumboFlyerPrintingRulesInches,
    name: DMDocumentNames.JUMBO,
    format: DMDocumentFormats.JUMBO as PossibleFlyerType,
    flyerTemplate: JumboFlyerTemplate,
    frontSide: FrontSideA6,
    backSide: BackSideA6,
    example: A6Example,
    preview: PreviewJumbo,
    placeholder: PreviewJumboPlaceholder,
    size: "105 × 148",
    measuring: "mm",
    heightInMm: 215.9, // 8.5 inch
    widthInMm: 279.4, // 11 inch
    displayWidth: 1056, // 279.4mm * 3.78
    displayHeight: 816, // 215.9mm * 3.78
    previewPadding: 0,
    gapForArrow: 14,
    horizontalArrow: JumboHorizontalArrow,
    verticalArrow: JumboVerticalArrow,
    verticalArrowHeight: 465,
    horizontalArrowWidth: 609,
    width: 1056, // 279.4mm * 3.78
    height: 816, // 215.9mm * 3.78
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMTcuNSA0NTkuMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzE3LjUgNDU5LjI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojMDEwMjAyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPHJlY3QgeD0iMTQuMiIgeT0iMTQuMiIgY2xhc3M9InN0MCIgd2lkdGg9IjI4OS4xIiBoZWlnaHQ9IjQzMC45Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSI5LjkiIHkxPSIxNC4yIiB4Mj0iMCIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iNDQ5LjMiIHgyPSIzMDMuMyIgeTI9IjQ1OS4yIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjQ0NSIgeDI9IjMxNy41IiB5Mj0iNDQ1Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjE0LjIiIHgyPSIzMTcuNSIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iOS45IiB4Mj0iMzAzLjMiIHkyPSIwIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIxNC4yIiB5MT0iOS45IiB4Mj0iMTQuMiIgeTI9IjAiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjE0LjIiIHkxPSI0NDkuMyIgeDI9IjE0LjIiIHkyPSI0NTkuMiIvPgo8bGluZSBjbGFzcz0ic3QxIiB4MT0iOS45IiB5MT0iNDQ1IiB4Mj0iMCIgeTI9IjQ0NSIvPgo8L3N2Zz4K",
    defaultOrientation: DocumentOrientation.Landscape,
    price: "$$$$",
  },
  OVERSIZED: {
    template: A6_Temlate,
    printingRulesMm: A6FlyerPrintingRulesMm,
    printingRulesInches: OversizedFlyerPrintingRulesInches,
    name: DMDocumentNames.OVERSIZED,
    format: DMDocumentFormats.OVERSIZED as PossibleFlyerType,
    flyerTemplate: OversizedFlyerTemplate,
    frontSide: FrontSideA6,
    backSide: BackSideA6,
    example: A6Example,
    preview: PreviewOversized,
    placeholder: PreviewOversizedPlaceholder,
    size: "105 × 148",
    measuring: "mm",
    heightInMm: 304.8, // 12 inch
    widthInMm: 381, // 15 inch
    displayWidth: 1440, // 381mm * 3.78
    displayHeight: 1152, // 304.8mm * 3.78
    previewPadding: 0,
    gapForArrow: 14,
    horizontalArrow: OversizedHorizontalArrow,
    verticalArrow: OversizedVerticalArrow,
    verticalArrowHeight: 586,
    horizontalArrowWidth: 736,
    width: 1440, // 381mm * 3.78
    height: 1152, // 304.8mm * 3.78
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMTcuNSA0NTkuMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzE3LjUgNDU5LjI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojMDEwMjAyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPHJlY3QgeD0iMTQuMiIgeT0iMTQuMiIgY2xhc3M9InN0MCIgd2lkdGg9IjI4OS4xIiBoZWlnaHQ9IjQzMC45Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSI5LjkiIHkxPSIxNC4yIiB4Mj0iMCIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iNDQ5LjMiIHgyPSIzMDMuMyIgeTI9IjQ1OS4yIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjQ0NSIgeDI9IjMxNy41IiB5Mj0iNDQ1Ii8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMDcuNiIgeTE9IjE0LjIiIHgyPSIzMTcuNSIgeTI9IjE0LjIiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjMwMy4zIiB5MT0iOS45IiB4Mj0iMzAzLjMiIHkyPSIwIi8+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIxNC4yIiB5MT0iOS45IiB4Mj0iMTQuMiIgeTI9IjAiLz4KPGxpbmUgY2xhc3M9InN0MSIgeDE9IjE0LjIiIHkxPSI0NDkuMyIgeDI9IjE0LjIiIHkyPSI0NTkuMiIvPgo8bGluZSBjbGFzcz0ic3QxIiB4MT0iOS45IiB5MT0iNDQ1IiB4Mj0iMCIgeTI9IjQ0NSIvPgo8L3N2Zz4K",
    defaultOrientation: DocumentOrientation.Landscape,
    price: "$$$$$",
  },
  POSTCARD_6x4: {
    template: DoorHangerFlyerEPS,
    printingRulesMm: A5FlyerPrintingRulesMm,
    printingRulesInches: A5FlyerPrintingRulesInches,
    flyerTemplate: ADMPostcard6x4Templates,
    name: ADMDocumentLabels.POSTCARD_6x4,
    format: "POSTCARD_6x4" as PossibleFlyerType,
    width: 576,
    height: 384,
    example: ExampleDoorHanger,
    preview: PreviewA5,
    placeholder: PreviewA5Placeholder,
    frontSide: FrontSideDoorHanger,
    backSide: BackSideDoorHanger,
    size: "152.4 x 101.6",
    measuring: "mm",
    widthInMm: 152.4,
    heightInMm: 101.6,
    displayWidth: 576,
    displayHeight: 384,
    gapForArrow: 17,
    previewPadding: 0,
    horizontalArrow: A5HorizontalArrow,
    verticalArrow: A5VerticalArrow,
    verticalArrowHeight: 528,
    horizontalArrowWidth: 373,
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNjkuMyA0NTMuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjY5LjMgNDUzLjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsMjk3LjZIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjI1LjVjMC02LjMsNS4xLTExLjMsMTEuMy0xMS4zaDIxOC4zYzYuMywwLDExLjMsNS4xLDExLjMsMTEuMwoJCXYyNjAuOEMyNTUuMSwyOTIuNiwyNTAsMjk3LjYsMjQzLjgsMjk3LjZ6Ii8+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsNDM5LjRIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjMwOWMwLTYuMyw1LjEtMTEuMywxMS4zLTExLjNoMjE4LjNjNi4zLDAsMTEuMyw1LjEsMTEuMywxMS4zCgkJVjQyOEMyNTUuMSw0MzQuMywyNTAsNDM5LjQsMjQzLjgsNDM5LjR6Ii8+CjwvZz4KPC9zdmc+Cg==",
    defaultOrientation: DocumentOrientation.Landscape,
    price: "$",
  },
  POSTCARD_9x6: {
    template: DoorHangerFlyerEPS,
    printingRulesMm: A5FlyerPrintingRulesMm,
    printingRulesInches: A5FlyerPrintingRulesInches,
    flyerTemplate: ADMPostcard9x6Templates,
    name: ADMDocumentLabels.POSTCARD_9x6,
    format: "POSTCARD_9x6" as PossibleFlyerType,
    width: 864,
    height: 576,
    example: ExampleDoorHanger,
    preview: PreviewA5,
    placeholder: PreviewA5Placeholder,
    frontSide: FrontSideDoorHanger,
    backSide: BackSideDoorHanger,
    size: "228.6 x 152.4",
    measuring: "mm",
    widthInMm: 228.6,
    heightInMm: 152.4,
    displayWidth: 864,
    displayHeight: 576,
    gapForArrow: 17,
    previewPadding: 0,
    horizontalArrow: A5HorizontalArrow,
    verticalArrow: A5VerticalArrow,
    verticalArrowHeight: 528,
    horizontalArrowWidth: 373,
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNjkuMyA0NTMuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjY5LjMgNDUzLjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsMjk3LjZIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjI1LjVjMC02LjMsNS4xLTExLjMsMTEuMy0xMS4zaDIxOC4zYzYuMywwLDExLjMsNS4xLDExLjMsMTEuMwoJCXYyNjAuOEMyNTUuMSwyOTIuNiwyNTAsMjk3LjYsMjQzLjgsMjk3LjZ6Ii8+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsNDM5LjRIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjMwOWMwLTYuMyw1LjEtMTEuMywxMS4zLTExLjNoMjE4LjNjNi4zLDAsMTEuMyw1LjEsMTEuMywxMS4zCgkJVjQyOEMyNTUuMSw0MzQuMywyNTAsNDM5LjQsMjQzLjgsNDM5LjR6Ii8+CjwvZz4KPC9zdmc+Cg==",
    defaultOrientation: DocumentOrientation.Landscape,
    price: "$$",
  },
  POSTCARD_11x6: {
    template: DoorHangerFlyerEPS,
    printingRulesMm: A5FlyerPrintingRulesMm,
    printingRulesInches: A5FlyerPrintingRulesInches,
    flyerTemplate: ADMPostcard11x6Templates,
    name: ADMDocumentLabels.POSTCARD_11x6,
    format: "POSTCARD_11x6" as PossibleFlyerType,
    width: 1056,
    height: 576,
    example: ExampleDoorHanger,
    preview: PreviewA5,
    placeholder: PreviewA5Placeholder,
    frontSide: FrontSideDoorHanger,
    backSide: BackSideDoorHanger,
    size: "279.4 x 152.4",
    measuring: "mm",
    widthInMm: 279.4,
    heightInMm: 152.4,
    displayWidth: 1056,
    displayHeight: 576,
    gapForArrow: 17,
    previewPadding: 0,
    horizontalArrow: A5HorizontalArrow,
    verticalArrow: A5VerticalArrow,
    verticalArrowHeight: 528,
    horizontalArrowWidth: 373,
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNjkuMyA0NTMuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjY5LjMgNDUzLjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsMjk3LjZIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjI1LjVjMC02LjMsNS4xLTExLjMsMTEuMy0xMS4zaDIxOC4zYzYuMywwLDExLjMsNS4xLDExLjMsMTEuMwoJCXYyNjAuOEMyNTUuMSwyOTIuNiwyNTAsMjk3LjYsMjQzLjgsMjk3LjZ6Ii8+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsNDM5LjRIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjMwOWMwLTYuMyw1LjEtMTEuMywxMS4zLTExLjNoMjE4LjNjNi4zLDAsMTEuMyw1LjEsMTEuMywxMS4zCgkJVjQyOEMyNTUuMSw0MzQuMywyNTAsNDM5LjQsMjQzLjgsNDM5LjR6Ii8+CjwvZz4KPC9zdmc+Cg==",
    defaultOrientation: DocumentOrientation.Landscape,
    price: "$$$",
  },
  POSTCARD_15x12: {
    template: DoorHangerFlyerEPS,
    printingRulesMm: A5FlyerPrintingRulesMm,
    printingRulesInches: A5FlyerPrintingRulesInches,
    flyerTemplate: OversizedFlyerTemplate,
    name: ADMDocumentLabels.POSTCARD_15x12,
    format: "POSTCARD_15x12" as PossibleFlyerType,
    width: 1440,
    height: 1152,
    example: ExampleDoorHanger,
    preview: PreviewA5,
    placeholder: PreviewA5Placeholder,
    frontSide: FrontSideDoorHanger,
    backSide: BackSideDoorHanger,
    size: "381 x 304.8",
    measuring: "mm",
    widthInMm: 381,
    heightInMm: 304.8,
    displayWidth: 1440,
    displayHeight: 1152,
    gapForArrow: 17,
    previewPadding: 0,
    horizontalArrow: A5HorizontalArrow,
    verticalArrow: A5VerticalArrow,
    verticalArrowHeight: 528,
    horizontalArrowWidth: 373,
    printLines:
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNjkuMyA0NTMuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjY5LjMgNDUzLjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojQzU0QzkwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsMjk3LjZIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjI1LjVjMC02LjMsNS4xLTExLjMsMTEuMy0xMS4zaDIxOC4zYzYuMywwLDExLjMsNS4xLDExLjMsMTEuMwoJCXYyNjAuOEMyNTUuMSwyOTIuNiwyNTAsMjk3LjYsMjQzLjgsMjk3LjZ6Ii8+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQzLjgsNDM5LjRIMjUuNWMtNi4zLDAtMTEuMy01LjEtMTEuMy0xMS4zVjMwOWMwLTYuMyw1LjEtMTEuMywxMS4zLTExLjNoMjE4LjNjNi4zLDAsMTEuMyw1LjEsMTEuMywxMS4zCgkJVjQyOEMyNTUuMSw0MzQuMywyNTAsNDM5LjQsMjQzLjgsNDM5LjR6Ii8+CjwvZz4KPC9zdmc+Cg==",
    defaultOrientation: DocumentOrientation.Landscape,
    price: "$$$$",
  },
};

export const FORMAT = {
  A4: {
    name: "A4",
    dimensions: "8.27 x 11.69\n210 x 297 mm",
    description:
      "This is the best option when there is a lot of information to include, such as menus, event schedules or product catalogs. Standard size Flyers work well for displaying on a bulletin board or wall.",
    preview: a4,
    uspsCompliant: false,
    width: "113.41px",
    height: "156.66px",
    orientation: "landscape",
  },
  A5: {
    name: "A5",
    dimensions: "8.27 x 5.83\n148 x 210 mm",
    description:
      "Good size to choose if the information to convey is succinct, like event announcements or product launches. Easy to distribute and can be handed out in public places or posted in high-visibility areas.",
    preview: a5,
    uspsCompliant: false,
    width: "99.96px",
    height: "136.48px",
    orientation: "portrait",
  },
  A6: {
    name: "A6",
    dimensions: "4.13 x 5.83\n105 x 148 mm",
    description:
      "This size is ideal for promoting sales, discounts or limited-time offers. This is a perfect size for handing out in high-traffic areas, like public transportation centers or shopping malls.",
    preview: a6,
    uspsCompliant: false,
    width: "73.04px",
    height: "99.96px",
    orientation: "portrait",
  },
  DOOR_HANGER: {
    name: "DOOR_HANGER",
    dimensions: "3.74 x 8.74\n95 x 222 mm",
    description: "This is the best option for door to door distribution.",
    preview: doorhanger,
    uspsCompliant: false,
    width: "79.18px",
    height: "173px",
    orientation: "portrait",
  },
  DL: {
    name: "DL",
    dimensions: "3.9 x 8.27\n99 x 210 mm",
    description:
      "They are an easy size for customers to pick up and take with them. This size will also fit in a standard envelope for mailing.",
    preview: dl,
    uspsCompliant: false,
    width: "82.66px",
    height: "165.31px",
    orientation: "portrait",
    useCase: "door-to-door",
  },
  TEARAWAY: {
    name: "TEARAWAY",
    dimensions: "3.34 x 5.9\n85 x 150 mm",
    description:
      "This size is ideal for promoting sales, discounts or limited-time offers. This is a perfect size for handing out in high-traffic areas.",
    preview: tearaway,
    uspsCompliant: false,
    width: "76.89px",
    height: "128.79px",
    orientation: "portrait",
  },
  SMALL: {
    name: "SMALL",
    dimensions: "4.25 x 11.6\n107.95 x 294.64 mm",
    description: "Small format ideal for direct mail campaigns. Perfect for concise messaging and easy handling.",
    preview: postcard4_25x11, // Using existing preview as placeholder
    uspsCompliant: true,
    width: "80px",
    height: "156px",
    orientation: "portrait",
  },
  BEST_SELLER: {
    name: "BEST_SELLER",
    dimensions: "6.25 x 9\n158.75 x 228.6 mm",
    description: "Best seller format, perfect for high-impact direct mail campaigns with balanced content.",
    preview: postcard6_25x9, // Using existing preview as placeholder
    uspsCompliant: true,
    width: "124px",
    height: "92px",
    orientation: "landscape",
  },
  LARGE: {
    name: "LARGE",
    dimensions: "6.25 x 11\n158.75 x 279.4 mm",
    description: "Large format for comprehensive content and maximum impact in direct mail campaigns.",
    preview: postcard6_25x11, // Using existing preview as placeholder
    uspsCompliant: true,
    width: "140px",
    height: "92px",
    orientation: "landscape",
  },
  JUMBO: {
    name: "JUMBO",
    dimensions: "8.5 x 11\n215.9 x 279.4 mm",
    description: "Jumbo format for maximum visibility and detailed content in direct mail campaigns.",
    preview: a4, // Using A4 preview as placeholder
    uspsCompliant: false,
    width: "113.41px",
    height: "156.66px",
    orientation: "portrait",
  },
  OVERSIZED: {
    name: "OVERSIZED",
    dimensions: "12 x 15\n304.8 x 381 mm",
    description: "Oversized format for maximum impact and detailed content in direct mail campaigns.",
    preview: a4, // Using A4 preview as placeholder
    uspsCompliant: false,
    width: "113.41px",
    height: "156.66px",
    orientation: "portrait",
  },
  POSTCARD_6x4: {
    name: "POSTCARD_6x4",
    dimensions: "4 x 6\n101.6 x 152.4 mm",
    description: "Standard postcard format for ADM campaigns, perfect for concise messaging.",
    preview: postcard4x6, // Using existing preview as placeholder
    uspsCompliant: true,
    width: "120px",
    height: "80px",
    orientation: "landscape",
  },
  POSTCARD_9x6: {
    name: "POSTCARD_9x6",
    dimensions: "6 x 9\n152.4 x 228.6 mm",
    description: "Large postcard format for ADM campaigns with more content space.",
    preview: postcard6_25x9, // Using existing preview as placeholder
    uspsCompliant: true,
    width: "124px",
    height: "92px",
    orientation: "landscape",
  },
  POSTCARD_11x6: {
    name: "POSTCARD_11x6",
    dimensions: "6 x 11\n152.4 x 279.4 mm",
    description: "Extra large postcard format for ADM campaigns with maximum content space.",
    preview: postcard6_25x11, // Using existing preview as placeholder
    uspsCompliant: true,
    width: "140px",
    height: "92px",
    orientation: "landscape",
  },
  POSTCARD_15x12: {
    name: "POSTCARD_15x12",
    dimensions: "12 x 15\n304.8 x 381 mm",
    description: "Maximum size postcard format for ADM campaigns with maximum impact.",
    preview: a4, // Using A4 preview as placeholder
    uspsCompliant: false,
    width: "113.41px",
    height: "156.66px",
    orientation: "portrait",
  },
};

export const FONT_FAMILIES = {
  Alegreya: {
    name: "Alegreya",
    fontFamily: "'Alegreya', serif",
    fontWeights: {
      400: "normal",
      // 500: "medium",
      700: "bold",
    },
    fontStyles: {
      regular: "Regular",
      italic: "Italic",
    },
  },
  "IBM Plex Sans": {
    name: "IBM Plex Sans",
    fontFamily: "'IBM Plex Sans', sans-serif",
    fontWeights: {
      // 300: "light",
      400: "normal",
      // 500: "medium",
      // 600: "semibold",
      700: "bold",
    },
    fontStyles: {
      regular: "Regular",
      italic: "Italic",
    },
  },
  "IBM Plex Serif": {
    name: "IBM Plex Serif",
    fontFamily: "'IBM Plex Serif', serif",
    fontWeights: {
      // 300: "light",
      400: "normal",
      // 500: "medium",
      // 600: "semibold",
      700: "bold",
    },
    fontStyles: {
      regular: "Regular",
      italic: "Italic",
    },
  },
  "Nunito Sans": {
    name: "Nunito Sans",
    fontFamily: "'Nunito Sans', sans-serif",
    fontWeights: {
      // 300: "light",
      400: "normal",
      // 600: "semibold",
      700: "bold",
    },
    fontStyles: {
      regular: "Regular",
      italic: "Italic",
    },
  },
  Roboto: {
    name: "Roboto",
    fontFamily: "'Roboto', sans-serif",
    fontWeights: {
      // 300: "light",
      400: "normal",
      // 500: "medium",
      700: "bold",
    },
    fontStyles: {
      regular: "Regular",
      italic: "Italic",
    },
  },
};

export const staticFonts = fonts;

export const GAP_BETWEEN_PAGES = 50;
export const SIZE_RESIZE_HANDLES = 10;
export const SIZE_RESIZE_HANDLES_CENTER = 5;
export const SELECTION_BOUNDS_HANDLES_MIN_SIZE = 1;
export const CUT_MARK_LENGTH = 20;

// const getBG = (type, width, height, bgUrl) => (
//   <>
//     <If condition={type === "guide"}>
//       <div style={{ width, height }}>
//         <img
//           style={{ pointerEvents: "none", userSelect: "none" }}
//           src={bgUrl}
//           alt="format bg"
//         />
//       </div>
//     </If>
//     <If condition={type === "white"}>
//       <div
//         style={{
//           width,
//           height,
//           backgroundColor: "white",
//           pointerEvents: "none",
//         }}
//       ></div>
//     </If>
//   </>
// );

export const CUT_MARK_BIAS = 0;

export const DOOR_HANGER_TRIANGLE_SIZE = [48, 58];
export const DOOR_HANGER_TRIANGLE_POS = [0, 104.5];

export const DOOR_HANGER_CIRCLE_SIZE = [118, 94];
export const DOOR_HANGER_CIRCLE_POS = [110, 86.5];
export const INF_VAL = 5000;

export const INTERVAL_SIZE = 38;

export const BLEED_AREA_SIZE: Partial<Record<PossibleFlyerType, number>> = {
  A5: 11,
  A6: 11,
  DOOR_HANGER: 8.5,
  TEARAWAY: 11,
  DL: 11,
  SMALL: 11,
  BEST_SELLER: 11,
  LARGE: 11,
  JUMBO: 11,
  OVERSIZED: 11,
  // POSTCARD_6_25x9: 11,
  // POSTCARD_4_25x11: 11,
  // POSTCARD_6_25x11: 11,
  POSTCARD_6x4: 11,
  POSTCARD_9x6: 11,
  POSTCARD_11x6: 11,
  POSTCARD_15x12: 11,
};

export const SAFE_AREA_SIZE: Partial<Record<PossibleFlyerType, number>> = {
  A5: 11,
  A6: 11,
  DOOR_HANGER: 9,
  TEARAWAY: 10,
  DL: 11,
  SMALL: 11,
  BEST_SELLER: 11,
  LARGE: 11,
  JUMBO: 11,
  OVERSIZED: 11,
  // POSTCARD_6_25x9: 11,
  // POSTCARD_4_25x11: 11,
  // POSTCARD_6_25x11: 11,
  POSTCARD_6x4: 11,
  POSTCARD_9x6: 11,
  POSTCARD_11x6: 11,
  POSTCARD_15x12: 11,
};

export const SECTIONS = {
  SETTINGS: "SETTINGS",
  IMAGES: "IMAGES",
  DRAWING: "DRAWING",
  TEXT: "TEXT",
  SHAPES: "SHAPES",
  ICONS: "ICONS",
  BG: "BG",
  QR_CODE: "QR_CODE",
  LAYERS: "LAYERS",
  VARIABLES: "VARIABLES",
  IMPORT_PDF: "IMPORT_PDF",
  AI_GENERATION: "AI_GENERATION",
  BRAND_KIT: "BRAND_KIT",
};

export const WHITE_BG_SIZE = [280, 460];
